// extracted by mini-css-extract-plugin
module.exports = {"innerModel":"inner-model_innerModel_1Qvr0","btn":"inner-model_btn_gNj7J","fileWrap":"inner-model_fileWrap_1B_3r","icon":"inner-model_icon_3YDrS"};